import { Dialog, DialogContent, Divider, MenuItem, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import { LOAN_TENURE_OPTIONS } from "../../../constants";
import { calculateMonthlyPayment, formatMoney } from "../../../../../shared/utils";


export default class LoanCalculator extends Component {

   state = {
      price: '',
      deposit: '',
      interest: '',
      tenure: '',
   }

   render() {

      const { price, deposit, interest, tenure } = this.state;
      let payments;

      if (price && deposit && interest && tenure) {

         const principal = price - deposit;
         
         const monthly = calculateMonthlyPayment(principal, interest, tenure);
         const totalInterest = monthly * tenure - principal;
         const total = principal + totalInterest;

         const data = {
            'Monthly Payment': formatMoney(monthly),
            'Total Interest': formatMoney(totalInterest),
            'Total': formatMoney(total),
         }

         payments = <div className="flex justify-between">
            {
               Object.keys(data).map(key => (
                  <div key={key} className="flex flex-col gap-1">
                     <div className="text-gray-500 text-xs">{key}</div>
                     <div className="text-lg">{data[key]}</div>
                  </div>
               ))
            }
         </div>

      } else {
         payments = <div className="text-center text-gray-500 text-xs">
            Populate all fields to display payments
         </div>
      }

      return <Dialog open>
         <DialogTitleWithCloseButton onClose={() => this.props.onClose()}>
            Loan Calculator
         </DialogTitleWithCloseButton>

         <DialogContent dividers>
            <div className="p-4 flex flex-col gap-4">
               <div className='grid grid-cols-2 gap-4'>
                  <TextField
                     label='Price'
                     type='number'
                     value={price}
                     onChange={e => this.setState({ price: e.target.value })}
                     size="small"
                     fullWidth
                  />
                  <TextField
                     label='Deposit'
                     type='number'
                     value={deposit}
                     onChange={e => this.setState({ deposit: e.target.value })}
                     size="small"
                     fullWidth
                  />
                  <TextField
                     label='Interest'
                     type='number'
                     value={interest}
                     onChange={e => this.setState({ interest: e.target.value })}
                     size="small"
                     fullWidth
                  />
                  <TextField
                     label='Tenure'
                     type='number'
                     value={tenure}
                     onChange={e => this.setState({ tenure: e.target.value })}
                     size="small"
                     fullWidth
                     select
                  >
                     {
                        LOAN_TENURE_OPTIONS.map(option => (
                           <MenuItem key={option} value={option}>
                              {option} months
                           </MenuItem>
                        ))
                     }
                  </TextField>      

               </div>

               <Divider />

               <div>
                  {payments}
               </div>
            </div>
         </DialogContent>
      </Dialog>
   }
}